/** Phone: dock compacto. Tablet: ainda usa a barra mobile, com compartilhar/gravar visíveis. */
export const PHONE_MAX_WIDTH_PX = 640;
export const TABLET_MAX_WIDTH_PX = 1024;

export function isPhoneViewport(width: number): boolean {
  return width <= PHONE_MAX_WIDTH_PX;
}

export function isTabletViewport(width: number): boolean {
  return width > PHONE_MAX_WIDTH_PX && width <= TABLET_MAX_WIDTH_PX;
}

/**
 * Barra mobile no retrato até tablet (iPad 768–1024).
 * Acima disso permanece o dock desktop.
 */
export function shouldUseMobileControlBar(width: number, isPortrait: boolean): boolean {
  return isPortrait && width <= TABLET_MAX_WIDTH_PX;
}

/**
 * Compartilhar tela e gravar precisam ficar no dock — não só no menu ⋯.
 * No tablet isso é obrigatório; no telefone também, senão a consultora não acha.
 */
export function shouldPromoteShareAndRecord(width: number, isPortrait: boolean): boolean {
  return shouldUseMobileControlBar(width, isPortrait) || isTabletViewport(width);
}
